var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp (25) 1",
    clipPath: "url(#clip0_13_7071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5031 0H12.4969C5.6047 0 1.64015e-05 5.60625 1.64015e-05 12.5C-0.00426344 15.1328 0.829155 17.6987 2.3797 19.8266L0.821891 24.4703L5.62658 22.9344C7.66466 24.2865 10.0573 25.0052 12.5031 25C19.3953 25 25 19.3922 25 12.5C25 5.60781 19.3953 0 12.5031 0Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7766 17.6517C19.475 18.5032 18.2782 19.2095 17.3235 19.4157C16.6704 19.5548 15.8172 19.6657 12.9454 18.4751C9.27192 16.9532 6.9063 13.2204 6.72192 12.9782C6.54536 12.736 5.23755 11.0017 5.23755 9.20791C5.23755 7.41416 6.14849 6.54072 6.51567 6.16572C6.81724 5.85791 7.31567 5.71729 7.7938 5.71729C7.94849 5.71729 8.08755 5.7251 8.21255 5.73135C8.57974 5.74697 8.76411 5.76885 9.0063 6.34854C9.30786 7.0751 10.0422 8.86885 10.1297 9.05322C10.2188 9.2376 10.3079 9.4876 10.1829 9.72979C10.0657 9.97979 9.96255 10.0907 9.77817 10.3032C9.5938 10.5157 9.4188 10.6782 9.23442 10.9063C9.06567 11.1048 8.87505 11.3173 9.08755 11.6845C9.30005 12.0438 10.0344 13.2423 11.1157 14.2048C12.511 15.447 13.6422 15.8438 14.0469 16.0126C14.3485 16.1376 14.7079 16.1079 14.9282 15.8735C15.2079 15.572 15.5532 15.072 15.9047 14.5798C16.1547 14.2267 16.4704 14.1829 16.8016 14.3079C17.1391 14.4251 18.925 15.3079 19.2922 15.4907C19.6594 15.6751 19.9016 15.7626 19.9907 15.9173C20.0782 16.072 20.0782 16.7985 19.7766 17.6517Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ee60bfac4c0ac027d77fbe6f8fee425b.svg";
export { ForwardRef as ReactComponent };